import { jsxs, jsx } from 'react/jsx-runtime';
import { Button as Button$1 } from '../ui/button.js';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import { Loader2 } from 'lucide-react';
import 'react';
import 'react-day-picker';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import './FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Enhanced Button component with standardized icon support
 * @param icon - Lucide icon component to display
 * @param iconPosition - Position of the icon relative to text
 * @param iconOnly - Whether this is an icon-only button
 * @param loading - Whether to show loading spinner and disable button
 * @param children - Button text content
 * @returns JSX element with standardized icon spacing
 */
const Button = ({ icon: Icon, iconPosition = 'left', iconOnly = false, loading = false, children, className, size, disabled, ...props }) => {
    // Icon-only buttons should use the icon size variant
    const buttonSize = iconOnly ? 'icon' : size;
    // Loading state overrides disabled state
    const isDisabled = loading || disabled;
    // When loading, show spinner instead of provided icon
    const DisplayIcon = loading ? Loader2 : Icon;
    const iconClassName = loading ? 'h-4 w-4 animate-spin' : 'h-4 w-4';
    return (jsxs(Button$1, { className: cn(className), size: buttonSize, disabled: isDisabled, ...props, children: [DisplayIcon && iconPosition === 'left' && !iconOnly && (jsx(DisplayIcon, { className: cn(iconClassName, 'mr-1') })), DisplayIcon && iconOnly && jsx(DisplayIcon, { className: iconClassName }), children, DisplayIcon && iconPosition === 'right' && !iconOnly && (jsx(DisplayIcon, { className: cn(iconClassName, 'ml-1') }))] }));
};

export { Button };
//# sourceMappingURL=Button.js.map
